import { IconX } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useRef, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { toast } from 'sonner';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import AddInfluencerModal from '../../Influencer/Components/AddInfluencerModal';
import { accessCheck } from '../../../utils/accessCheck';
import { accessKeys } from '../../../statics/accessKeys';

const LinkInfluencerToAgentModal = ({ buttonComponent, agentData }) => {
    const [show, setShow] = useState(false);
    const [finalList, setFinalList] = useState([]);
    const [loadingState, setLoadingState] = useState(false);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [showCreateButton, setShowCreateButton] = useState(false);
    const closeBtnRef = useRef(null);

    const handleClose = () => { setFinalList([]); setShowCreateButton(false); setShow(false) };
    const handleShow = () => setShow(true);

    const search = async (e) => {
        if (e.target.value.length >= 3) {
            setShowCreateButton(true);
            setLoadingState(true);
            let resp = await getApi(`${urlApi.searchInfluencer}?search=${e.target.value}`);
            setLoadingState(false);
            if (resp.responseCode === 200) {
                setFinalList(resp.data);
            } else {
                setFinalList([]);
            }
        } else {
            toast.warning("Type minimum of 3 letters!");
            setFinalList([]);
        }
    }

    function onAgentSelect(data) {
        setSelectedEntity(data);
        setFinalList(null)
        document.getElementById('searchName').value = data.channelName;
    }

    const add = async () => {
        loadingShow();
        let resp = await getApi(`${urlApi.linkInfluencerToAgent}${agentData?._id}/${selectedEntity?._id}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Add an Influencer To This Agent ({agentData?.name}).</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="top-label-input-group mb-2">
                        <div>
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Select Influencer</label>
                            <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='Influencer Name / Mobile / Email' id='searchName' onChange={_debounce((e) => search(e), 600)} />
                        </div>
                        <div className="max-h-80 overflow-y-auto mb-6">
                            {
                                loadingState ?
                                    <div className='mt-2 flex justify-center w-full'> <Spinner /></div> : (finalList?.length > 0 &&
                                        finalList?.map((item) => (
                                            <div key={item?._id} className='cursor-pointer hover:bg-gray-200 px-3 py-2 rounded-md text-sm flex items-center flex-wrap gap-2' onClick={() => onAgentSelect(item)}>
                                                <img src={item?.channelLogo} alt="" className='h-7' />
                                                {item?.channelName}
                                            </div>
                                        )))
                            }
                        </div>
                        <div>
                            {(accessCheck(accessKeys.createAndEditAgent) && showCreateButton) && <div className='flex justify-center items-center gap-3'>
                                <p className='text-sm font-semibold text-[#273144]'>Can't find your Influencer?</p>
                                <AddInfluencerModal buttonComponent={<button className='primary-btn' >Create and Link</button>} agentData={agentData} callbackClose={closeBtnRef} />
                            </div>}
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' ref={closeBtnRef} onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => add()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default LinkInfluencerToAgentModal